(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["una-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-una-rail]');
  if (!btn) return;
  var wrap = btn.closest('.una-carousel');
  var rail = wrap && wrap.querySelector('[data-una-railtrack]');
  if (!rail) return;
  var dir = btn.getAttribute('data-una-rail') === 'prev' ? -1 : 1;
  rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["una-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var drawer = document.getElementById('una-drawer');
  var opener = document.querySelector('[data-una-drawer-open]');

  function setOpen(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (opener) opener.setAttribute('aria-expanded', String(open));
    if (open) { var c = drawer.querySelector('[data-una-drawer-close]'); if (c) c.focus(); }
    else if (opener) opener.focus();
  }

  // The account menu is a <details>: close it on an outside click or Escape.
  function closeAcct(except) {
    document.querySelectorAll('[data-una-acct][open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-una-drawer-open]')) { setOpen(true); }
    else if (e.target.closest('[data-una-drawer-close]')) { setOpen(false); }
    closeAcct(e.target.closest('[data-una-acct]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) setOpen(false);
    var open = document.querySelector('[data-una-acct][open]');
    if (open) { open.removeAttribute('open'); var s = open.querySelector('summary'); if (s) s.focus(); }
  });

  // Server-rendered so the date is right at first paint, then corrected here in
  // case the page was served from cache.
  var d = document.querySelector('[data-una-date]');
  if (d) {
    try {
      d.textContent = new Date().toLocaleDateString('en-GB', {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
      });
    } catch (err) {}
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["una-work"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-una-play]');
  if (!btn) return;
  var wrap = btn.closest('[data-una-film]');
  if (!wrap) return;
  var poster = wrap.querySelector('.una-film-poster');
  var player = wrap.querySelector('.una-film-player');
  var video = player && player.querySelector('video');
  if (!player || !video) return;
  player.hidden = false;
  if (poster) poster.hidden = true;
  var p = video.play();
  if (p && p.catch) p.catch(function () {});
});

  } catch(e) { console.error(e); }
})();
})();
